import React from "react";
import { Container, Typography, Box, Grid } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const features = [
  {
    id: 1,
    title: "Design & Customize Tickets",
    description:
      "Design and launch your ticketing page in minutes—no coding required.",
    imgSrc: "/images/design.svg",
  },
  {
    id: 2,
    title: "Sell & Promote Events",
    description:
      "Share your event page, embed ticket sales on your website, and leverage promo code.",
    imgSrc: "/images/sell.svg",
  },
  {
    id: 3,
    title: "Manage & Track Sales",
    description:
      "Monitor ticket sales, scan check-ins, and engage with attendees effortlessly.",
    imgSrc: "/images/manage.svg",
  },
];

export default function HassleFreeApproach() {
  return (
    <Container>
      <Typography
        variant="h4"
        align="center"
        sx={{
          fontSize: { xs: 24, sm: 32, md: 40 },
          fontWeight: 700,
          textAlign: "center",
          "@keyframes gradientMove": {
            "0%": { backgroundPosition: "0% 50%" },
            "50%": { backgroundPosition: "100% 50%" },
            "100%": { backgroundPosition: "0% 50%" },
          },
        }}
      >
        A hassle-free approach to
        <br />
        <span className="txt-shine">designing & selling</span>
        &nbsp;your event tickets
      </Typography>

      <Box sx={{ textAlign: "center", mt: 8, mb: 13 }}>
        {/* Top numbered steps with dashed line */}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={4}
          sx={{ mb: 4 }}
        >
          {features.map((feature, index) => (
            <Grid item key={feature.id} xs={4} sx={{ position: "relative" }}>
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  backgroundColor: "#333",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  margin: "0 auto",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                {feature.id}
              </Box>
              {index < features.length - 1 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "70%",
                    left: "50%",
                    width: "89%",
                    borderTop: "2px dashed #535353",
                    transform: "translate(10%, -50%)",
                    zIndex: 1,
                  }}
                />
              )}
            </Grid>
          ))}
        </Grid>

        {/* Feature cards */}
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="flex-start"
        >
          {features.map((feature) => (
            <Grid item xs={12} sm={6} md={4} key={feature.id}>
              <img
                src={feature.imgSrc}
                alt={feature.title}
                width={64}
                height={64}
                style={{ marginBottom: 16 }}
              />
              <Typography
                variant="h6"
                fontWeight={600}
                color="#333"
                gutterBottom
              >
                {feature.title}
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                  maxWidth: 300,
                  margin: "0 auto",
                }}
              >
                {feature.description}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
}
